import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_205: DocMigration = {
  maxSchemaVersion: "0.0.205",
  description: "Set window shape defaults",
  apply(json: any) {
    //setting default window shape for window descriptors
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];

      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const windowTypeId in setting.windowTypes) {
          const windowType = setting.windowTypes[windowTypeId];
          windowType.shape = "RECTANGLE";
        }
      }
    }

    return json;
  },
};

export default migration_0_0_205;
